export default "__VITE_ASSET__lAlBcf90__"